import { computed, type ComputedRef, type Ref, ref } from 'vue'
import StoneModal from '@/components/stone/search/sku/StoneModal.vue'
import GemstoneModal from '@/components/stone/search/nonsku/modal/GemstoneModal.vue'
import LabGrownDiamondModal from '@/components/stone/search/nonsku/modal/LabGrownDiamondModal.vue'
import { assertNever } from '@/helpers'
import type { RingBuilder } from '@/plugins/ring-builder.ts'
import type { ExtractComponentProps } from '@/types/vue.ts'

type Component =
    | {
          is: typeof StoneModal
          props: ExtractComponentProps<typeof StoneModal>
          events: { close(): void }
      }
    | {
          is: typeof LabGrownDiamondModal
          props: ExtractComponentProps<typeof LabGrownDiamondModal>
          events: { close(): void }
      }
    | {
          is: typeof GemstoneModal
          props: ExtractComponentProps<typeof GemstoneModal>
          events: { close(): void }
      }
    | undefined
export function useEngagementRing3rdStepStoneModal(ringBuilder: RingBuilder): {
    isOpen: Ref<boolean>
    open(): void
    component: ComputedRef<Component>
} {
    const isOpen = ref(false)

    const open = () => {
        isOpen.value = true
    }
    const close = () => {
        isOpen.value = false
    }

    const component = computed((): Component => {
        const stone = ringBuilder.stone.value
        if (!stone) {
            return undefined
        }

        switch (stone.__typename) {
            case 'GemsApi_Stone':
                return {
                    is: StoneModal,
                    props: {
                        stoneId: stone.identifier,
                        pageType: 'product-details',
                    },
                    events: { close },
                }
            case 'NonSkuLabGrown':
                return {
                    is: LabGrownDiamondModal,
                    props: { stone, pageType: 'product-details' },
                    events: { close },
                }
            case 'NonSkuGemstone':
                return {
                    is: GemstoneModal,
                    props: { stone, pageType: 'product-details' },
                    events: { close },
                }
            default:
                return assertNever(stone, undefined)
        }
    })

    return {
        isOpen,
        open,
        component,
    }
}
